declare global {
  interface Window {
    __STATSIG_ENVIRONMENT_TIER__?: string;
  }
}

/**
 * Returns the Statsig environment tier for SDK initialization.
 *
 * In SSR-rendered pages, the tier is injected by server-renderer as
 * window.__STATSIG_ENVIRONMENT_TIER__ ('staging' for preview, absent for production).
 *
 * Returns undefined for production — Statsig treats no tier as production by default.
 *
 * @see https://docs.statsig.com/guides/using-environments
 */
const getEnvironmentTier = (): string | undefined => {
  return window.__STATSIG_ENVIRONMENT_TIER__ || undefined;
};

export default getEnvironmentTier;
